import { produce } from 'immer';
import { EPaymentMethod } from "../../../../../../../dependencies/getContent/constants";
import { EStatus } from "../../../../../../../../constants";
import { pollSbpStatusUseCase } from "../../QRModal/logic/pollSbpStatus.case";
import { initializeUseCase } from "../../logic/initializeQr.case";
// Returns props for rendering bank list view in SBP modal
export var getBankListProps = function getBankListProps(_ref) {
  var getSBPBanks = _ref.getSBPBanks,
    initializeQRCode = _ref.initializeQRCode,
    initializeSBPBanks = _ref.initializeSBPBanks,
    pollSbpStatus = _ref.pollSbpStatus;
  return function (getState, setState) {
    var _state$scenario, _state$scenario$searc;
    var state = getState();
    if (((_state$scenario = state.scenario) === null || _state$scenario === void 0 ? void 0 : _state$scenario.type) !== EPaymentMethod.SBP) return undefined;
    var searchValue = (_state$scenario$searc = state.scenario.searchInputValue) !== null && _state$scenario$searc !== void 0 ? _state$scenario$searc : '';
    return {
      type: 'bank-list',
      onMount: function onMount() {
        initializeUseCase({
          initializeQRCode: initializeQRCode,
          initializeSBPBanks: initializeSBPBanks
        })(state, setState).catch(console.error);
      },
      handlePayProcess: function handlePayProcess() {
        setState(produce(function (draft) {
          draft.statusPopup = EStatus.Processing;
          draft.scenario = undefined;
        }));
        pollSbpStatusUseCase({
          pollSbpStatus: pollSbpStatus
        })(getState, setState).catch(console.error);
      },
      bankList: getSBPBanks().filter(function (item) {
        return item.bankName.toLowerCase().includes(searchValue.toLowerCase());
      }),
      onClose: function onClose() {
        setState(produce(function (draft) {
          draft.scenario = undefined;
        }));
      },
      inputHandler: function inputHandler(value) {
        setState(produce(function (draft) {
          var _draft$scenario;
          if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) === EPaymentMethod.SBP) {
            draft.scenario.searchInputValue = value;
          }
        }));
      },
      search: searchValue
    };
  };
};